package com.partejar.app.feature.agenda.data.remote

import com.partejar.app.core.network.ApiConfig
import com.partejar.app.core.session.CurrentWorkspaceRepository
import com.partejar.app.feature.agenda.data.AgendaDataSource
import com.partejar.app.feature.agenda.data.AgendaEvent
import com.partejar.app.feature.agenda.data.AgendaPatientDestination
import com.partejar.app.feature.agenda.data.AgendaPeriod
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.client.request.header
import io.ktor.client.request.parameter
import io.ktor.http.HttpStatusCode
import kotlinx.coroutines.CancellationException
import kotlinx.serialization.Serializable

@Serializable
private data class AgendaEventDto(
    val id: Long,
    val tipo: String,
    val titulo: String,
    val inicioEm: String,
    val fimEm: String,
    val pacienteId: Long? = null,
    val nomeGestante: String? = null,
    val statusPaciente: String? = null
)

class AgendaRemoteDataSource(
    private val client: HttpClient,
    private val apiConfig: ApiConfig,
    private val workspace: CurrentWorkspaceRepository
) : AgendaDataSource {
    override suspend fun list(period: AgendaPeriod): List<AgendaEvent> = try {
        val response = client.get(apiConfig.endpoint("/agenda")) {
            header("X-Workspace-Id", workspace.currentWorkspaceId() ?: error("Workspace não selecionado"))
            parameter("inicio", period.startDate)
            parameter("fim", period.endDate)
        }
        if (response.status != HttpStatusCode.OK) {
            throw IllegalStateException("Falha ao carregar agenda (${response.status.value})")
        }
        response.body<List<AgendaEventDto>>().map(::toModel).sortedBy { it.startsAt }
    } catch (error: CancellationException) {
        throw error
    }

    private fun toModel(item: AgendaEventDto): AgendaEvent = AgendaEvent(
        id = item.id,
        type = item.tipo,
        title = item.titulo,
        startsAt = item.inicioEm,
        endsAt = item.fimEm,
        patientId = item.pacienteId,
        patientName = item.nomeGestante,
        patientDestination = when (item.statusPaciente) {
            "ATIVA" -> AgendaPatientDestination.GESTANTE
            "CAPTACAO", "REUNIAO_APRESENTACAO", "AGUARDANDO_FECHAMENTO", "CONTRATO" -> AgendaPatientDestination.RELACIONAMENTO
            else -> null
        }
    )
}
